import { createStyles } from 'antd-style';

export const useHasDialogStyles = createStyles(() => ({
  hasDialog: {
    '.ant-btn, .InlineLink': {
      opacity: 0.35,
    },
  },
}));
